import React from 'react';
import { StatCardBone } from './Bone';

// Full class names so Tailwind keeps them.
const COLS = {
    1: 'xl:grid-cols-1',
    2: 'xl:grid-cols-2',
    3: 'xl:grid-cols-3',
    4: 'xl:grid-cols-4',
    5: 'xl:grid-cols-5',
    6: 'xl:grid-cols-6'
};

/** Row of KPI card placeholders. `cards` (alias `count`) sets how many. */
export default function AnalyticsSkeleton({ cards, count }) {
    const total = cards ?? count ?? 4;
    return (
        <div className={`grid gap-4 grid-cols-1 sm:grid-cols-2 ${COLS[total] || COLS[4]} mb-4`} aria-busy="true">
            {Array.from({ length: total }).map((_, index) => (
                <StatCardBone key={index} />
            ))}
        </div>
    );
}
